import StatusHandler from 'app/shared-components/StatusHandler'

import useGetForecast from 'app/requests/Forecast/hooks/useGetForecast'
import ShortTermForecastForm from '../ShortTermForecastForm'

export default function ShortTermForecastOverview({
    id,
}: { id: number }) {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetForecast(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ShortTermForecastForm
                data={data}
                disabled
            />
        </StatusHandler>
    )
}
